import React, { Component } from 'react';
import { Alert, Table, Label, ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem, Input, InputGroup, Form, Popover, PopoverBody, Button } from 'reactstrap';

export default class BoardsList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            boards: [],
            members: [],
            searchText: '',
            showSearchMessage: true,
            searchPopoverIsOpen: false
        };
    }

    componentDidMount() {
        //default to returning boards as initial result
        this.getBoards();
    }

    closeSearchPopover = () => {
        this.setState({ searchPopoverIsOpen: false });
    }

    getBoards = (searchText) => {
        var searchString = searchText ? "&searchText=" + searchText : "";
        fetch('/api/boards?isActive=true' + searchString, {
            method: 'GET'
        })
            .then(resp => resp.json())
            .then(data => {
                this.setState({ boards: data });
            })
        this.setState({ searchType: "Board" });
    }

    getMembers = (searchText) => {
        var searchString = searchText ? "&searchText=" + searchText : "";
        fetch('/api/boardmembers?isActive=true' + searchString, {
            method: 'GET'
        })
            .then(resp => resp.json())
            .then(data => {
                this.setState({ members: data });
            })
        this.setState({ searchType: "Member", showSearchMessage: false });
    }

    createBoardTable = () => {
        return (
            <Table bordered responsive hover striped>
                <thead>
                    <tr>
                        <th>Board Name</th>
                    </tr>
                </thead>
                <tbody>
                    {this.state.boards && this.state.boards.length > 0 && this.state.boards.map(b => {
                        return (
                            <tr key={b.id} onClick={() => this.handleRowClick(b.id)}>
                                <td style={{ cursor: "pointer" }}>{b.name}</td>
                            </tr>
                        )
                    })}
                </tbody>
            </Table>
        )
    }

    createMemberTable = () => {
        return (
            <Table className="mobile-table" bordered responsive striped>
                <thead>
                    {!this.state.showSearchMessage &&
                        <tr>
                            <th>Member Name</th>
                            <th>Board Name</th>
                            <th>Title</th>
                            <th>Position</th>
                            <th>Expiration Date</th>
                        </tr>
                    }
                </thead>
                <tbody>
                    {this.state.members && this.state.members.length > 0 && this.state.members.map(m => {
                        return (
                            <tr key={m.id}>
                                <td data-title="Member Name">{((m.firstName ? m.firstName + " " : "") + (m.middleName ? m.middleName + " " : "") + (m.lastName ? m.lastName : ""))}</td>
                                <td data-title="Board Name">{m.boardName}</td>
                                <td data-title="Title">{m.title}</td>
                                <td data-title="Position">{m.position}</td>
                                <td data-title="Expiration Date">{(m.expirationDate ? new Date(m.expirationDate).toLocaleDateString("en-US") : "")}</td>
                            </tr>
                        )
                    })}
                    {this.state.members.length === 0 && !this.state.showSearchMessage &&
                        <tr>
                            <td colSpan='5'>Your search returned no results</td>
                        </tr>
                    }
                    {this.state.members.length === 0 && this.state.showSearchMessage &&
                        <tr>
                            <th colSpan='5'>Use the seach box above to search for the desired board member</th>
                        </tr>
                    }
                </tbody>
            </Table>
        )
    }

    handleSearch = (e) => {
        e.preventDefault();
        if (this.state.searchType === "Board") {
            this.getBoards(this.state.searchText);
        }
        if (this.state.searchType === "Member") {
            if (this.state.searchText.trim() === "") {
                e.stopPropagation();
                this.setState({ searchPopoverIsOpen: true })
            } else {
                this.getMembers(this.state.searchText);
            }
        }
    }

    handleReset = () => {
        this.setState({ searchText: "" });
        if (this.state.searchType === "Board") {
            this.getBoards();
        }
        if (this.state.searchType === "Member") {
            this.setState({ members: [], showSearchMessage: true });
        }
    }

    handleChange = (e) => {
        this.setState({ searchText: e.target.value });
    }

    handleRowClick = (id) => {
        this.props.history.push('board/' + id);
    }

    toggle = () => {
        this.setState({ dropdownOpen: !this.state.dropdownOpen });
    }

    chooseSearchType = (e) => {
        if (e.target.value === "Board") {
            this.getBoards();
        }
        this.setState({ searchType: e.target.value, dropdownOpen: false });
    }
  
    render() {
        return (
            <div>
                <Form onSubmit={this.handleSearch}>
                    <Alert color='secondary'>
                        <p className='mb-1'>
                            Browse the below table in order to find desired board or commissions.
                            Select a board to find information about a particular board.
                        </p>
                        <p className='mb-1'>
                            To search by a specific board member, change the view to Board Member.
                        </p>
                    </Alert>
                    <ButtonDropdown isOpen={this.state.dropdownOpen} toggle={this.toggle}>
                        <DropdownToggle caret size="lg" color="primary">View By</DropdownToggle>
                        <DropdownMenu>
                            <DropdownItem value="Board" onClick={(e) => this.chooseSearchType(e)}>Board Name</DropdownItem>
                            <DropdownItem value="Member" onClick={(e) => this.chooseSearchType(e)}>Board Member</DropdownItem>
                        </DropdownMenu>
                    </ButtonDropdown>
                    <br />
                    <br />
                    {this.state.searchType &&
                        <div>
                            <Alert color="primary" tag="h5"><Label>{this.state.searchType === "Board" ? "Boards and Commissions" : "Board Members"}</Label></Alert>
                            <Popover className="popover-custom" placement='top-start' isOpen={this.state.searchPopoverIsOpen} target="searchText">
                                <PopoverBody>Please enter a search phrase</PopoverBody>
                            </Popover>
                            <InputGroup id="searchInputGroup">                                
                                <Input
                                    id="searchText"
                                    placeholder={this.state.searchType === "Board" ? "Search by Board Name" : "Search by Member Name"}
                                    onChange={(e) => this.handleChange(e)} value={this.state.searchText || ''}
                                    onClick={this.closeSearchPopover}
                                />
                                <Button color="secondary" style={{ border: "1px solid black" }} type='submit'>Search</Button>
                                <Button color="secondary" style={{ border: "1px solid black" }} onClick={this.handleReset}>Reset</Button>                                
                            </InputGroup>
                            <br />
                            {this.state.searchType === "Board" ? this.createBoardTable() : this.createMemberTable() }
                        </div>
                    }
                </Form>
            </div>
        )

    }

}